export default __webpack_public_path__ + "static/media/6-sgi-matricula-v1.d5314a1c.png";